// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-udbib{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-info-__slug-indexstyleGrid-grid-bauok{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-bgths{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-fjhqi{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-emofq{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-bgxgu{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-ouvvq{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-ryjrb{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-udbib",
	"grid": "pages-info-__slug-indexstyleGrid-grid-bauok",
	"col6": "pages-info-__slug-indexstyleGrid-col6-bgths",
	"col3": "pages-info-__slug-indexstyleGrid-col3-fjhqi",
	"col4": "pages-info-__slug-indexstyleGrid-col4-emofq",
	"col9": "pages-info-__slug-indexstyleGrid-col9-bgxgu",
	"col12": "pages-info-__slug-indexstyleGrid-col12-ouvvq",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-ryjrb"
};
module.exports = ___CSS_LOADER_EXPORT___;
